import React from "react";
import { MdChevronRight } from "react-icons/md";
import Button from "../../../../components/shared/Button/Button";
import Card from "../../../../components/shared/Card/Card";
import Accordion from "../../../../components/shared/Accordion/Accordion";
import Spinner from "../../../../components/shared/spinner/Spinner";
import { useComparisonAiHighlight } from "../../hooks/useComparisonAiHighlight";
import MarkdownRenderer from "../../../swing_library/components/Newton/components/Body/MarkdownRenderer";
import { stripMarkdown } from "../../../swing_library/components/Newton/utils/sse";
import { useNewton } from "../../../swing_library/components/Newton/store/NewtonContext";
import { swingCollectionsService } from "../../../../services/swingCollections";

const SummaryAI = ({ collectionOne, collectionTwo }) => {
  const { setPendingSessionId, setIsNewtonOpen } = useNewton();

  const { data, isFetching, isError } = useComparisonAiHighlight({
    collectionOne,
    collectionTwo,
  });

  const summaryText = stripMarkdown(data?.result || "");
  const hasCollectionOneVideos = Boolean(collectionOne?.videoIds?.length);

  const handleDiveDeeper = async () => {
    if (!data?.llmSessionId) return;
    if (data?.highlightId) {
      try {
        // await swingCollectionsService.preserveLlmSession({
        //   highlightId: data.highlightId,
        // });
      } catch {
        console.error("Failed to preserve LLM session");
      }
    }
    setPendingSessionId(data.llmSessionId);
    setIsNewtonOpen(true);
  };

  return (
    <Card color="gray50" rounded="xl">
      <Accordion
        arrowColor="text-gray700"
        content={
          <>
            <div className="mb-6 flex flex-col gap-4">
              {!hasCollectionOneVideos && (
                <p className="text-gray900 text-xs">
                  Add more swings to generate an AI summary.
                </p>
              )}

              {hasCollectionOneVideos && isFetching && (
                <div className="flex items-center gap-2 text-xs text-gray700">
                  <Spinner color="primary500" size="sm" />
                  Generating AI summary...
                </div>
              )}

              {hasCollectionOneVideos && isError && (
                <p className="text-gray900 text-xs">
                  Unable to generate summary right now. Please try again later.
                </p>
              )}

              {hasCollectionOneVideos && !isFetching && !isError && (
                <div className="text-gray900 text-xs">
                  {summaryText ? (
                    <MarkdownRenderer>{summaryText}</MarkdownRenderer>
                  ) : (
                    <p>No summary available yet.</p>
                  )}
                </div>
              )}
            </div>

            <Button
              className="w-fit"
              color="black"
              disabled={
                !data?.llmSessionId ||
                !(
                  hasCollectionOneVideos &&
                  !isFetching &&
                  !isError &&
                  summaryText
                )
              }
              endContent={<MdChevronRight className="size-5" />}
              onClick={handleDiveDeeper}
              size="sm"
            >
              Dive Deeper with Newton
            </Button>
          </>
        }
        contentPadding="px-6 pb-6"
        openedByDefault={true}
        title={
          <h2 className="text-primary700 text-lg font-semibold">AI Summary</h2>
        }
        titlePadding="p-6"
      />
    </Card>
  );
};

export default SummaryAI;
